<template>
  <div id="EULA">
    <h3>SOFTWARE LICENSE TERMS</h3>
    The software is owned by Aalborg University and made available under the BSD License 2.0. 
    <br><br>
    NOTE: The pre-defined generic patients, does not represent any real person, and are intended only for teaching purposes. Further, the possibilities to suggest specific medicine, and see resulting effect on such generic patients shall in no way be seen as instruction on how to medicate any real patients. The software is not approved for use on patients or in connection with patient care and treatment.
    <br><br>
    LICENSE GRANT
    Subject to the terms and conditions of these SOFTWARE LICENSE TERMS, Aalborg university hereby grants you a worldwide, royalty-free, non-sublicensable, non-exclusive, irrevocable license to exercise the software to:
    <ul>
      <li>reproduce and share the software, in whole or in part, for non-commercial purposes only (non-commercial means not primarily intended for or directed towards commercial advantage or monetary compensation); and</li>
      <li>produce, reproduce, and share derived software for non-commercial purposes only (derived software means any copyright and similar rights that is derived from or based upon the software and in which the software is translated, altered, arranged, transformed, or otherwise modified in a manner requiring permission under the copyrights held by Aalborg University).</li>
    </ul>
    Copyright (c) 2023, Aalborg University
    <br>
    All rights reserved.
    <br><br>
    Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
    <ul>
      <li>Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.</li>
      <li>Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.</li>
      <li>Neither the name of Aalborg University nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.</li>
    </ul>
    THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL Aalborg University BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
    <br><br>
    By accepting the SOFTWARE LICENSE TERMS you also accept the use of cookies <router-link to="/legal">as defined in the GDPR Policy</router-link>.
  </div>
</template>
<script>
export default {
  name: 'EULA',
}
</script>
<style scoped>
  #EULA{
    text-align: left;
  }
  h3{
    text-align: center;
  }
  ul{
    list-style-position: outside;
  }
</style>
  